import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function Scanning() {
  const { t } = useTranslation();
  const steps = [
    t('scanning.step_connect'),
    t('scanning.step_read'),
    t('scanning.step_cross'),
    t('scanning.step_verdict'),
  ];
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setActive((a) => Math.min(a + 1, steps.length - 1)),
      420
    );
    return () => clearInterval(id);
  }, [steps.length]);

  return (
    <section className="scanning">
      <div className="scanning__radar" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <h2 className="scanning__title">{t('scanning.title')}</h2>
      <p className="scanning__subtitle">{t('scanning.subtitle')}</p>
      <ul className="scanning__steps">
        {steps.map((s, i) => (
          <li key={i} className={i <= active ? 'is-done' : ''}>
            <span className="scanning__dot" />
            {s}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Scanning;
